import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=9672657e&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9672657e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9672657e')) {
      api.createRecord('9672657e', component.options)
    } else {
      api.reload('9672657e', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=9672657e&scoped=true&", function () {
      api.rerender('9672657e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Home.vue"
export default component.exports